import clsx from 'clsx'
import { IHeroProps } from './types'
import styles from './styles.module.scss'

const Hero = ({
  backgroundImage,
  cta,
  size = 'md',
  text,
  theme,
  title,
  variant = 'center',
}: IHeroProps) => {
  const renderTitle =
    typeof title === 'string' ? (
      <h1 className={clsx('headline-h2', styles.title, styles[theme])}>{title}</h1>
    ) : (
      <div className={styles.title}>{title}</div>
    )
  const renderText =
    typeof text === 'string' ? (
      <p className={clsx('body-18-default', styles.text, styles[theme])}>{text}</p>
    ) : (
      <div className={styles.text}>{text}</div>
    )

  return (
    <header
      className={clsx('mui-hero', styles.hero, styles[size], styles[variant])}
      data-testid="mui-hero"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      {title && renderTitle}
      {text && renderText}
      {cta && <div className={styles.cta}>{cta}</div>}
    </header>
  )
}

export default Hero
